







import Vue from 'vue'
import IconCircleOutlinezero from '@/assets/svg/circle-outlinezero.svg?inline'

interface Props {
  title: string
}

export default Vue.extend<{}, {}, {}, Props>({
  components: {
    IconCircleOutlinezero,
  },
  props: {
    title: {
      default: () => '',
    },
  },
})
